import SectionHeading from '@/components/base/SectionHeading';
import PlatformCard from '@/components/base/PlatformCard';
import ForumCard from '@/components/base/ForumCard';
import ArticleCard from '@/components/base/ArticleCard';
import { platforms } from '@/mocks/platforms';
import { forums } from '@/mocks/forums';
import { articles } from '@/mocks/articles';

export default function ContentSections() {
  const featuredPlatforms = [...platforms].sort((a, b) => b.heat - a.heat).slice(0, 6);
  const featuredForums = forums.slice(0, 3);
  const featuredArticles = articles.slice(0, 3);

  return (
    <>
      <section id="platforms" className="border-b border-background-200 bg-background-50">
        <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
          <SectionHeading
            eyebrow="本周热度榜"
            title="最常被用到的爆料平台"
            description="按近期访问热度排序，全部条目都在最近一轮核验中确认可正常访问。"
            actionLabel="进入平台导航大全"
            actionTo="/directory"
          />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {featuredPlatforms.map((platform, index) => (
              <PlatformCard key={platform.id} platform={platform} rank={index + 1} />
            ))}
          </div>
        </div>
      </section>

      <section id="forums" className="bg-background-100">
        <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
          <SectionHeading
            eyebrow="讨论版块"
            title="论坛社区：找到正在讨论同一件事的人"
            description="比起单打独斗，找到同温层一起整理材料、同步进度，往往更容易推动问题解决。"
            actionLabel="浏览全部社区"
            actionTo="/forums"
          />
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {featuredForums.map((forum) => (
              <ForumCard key={forum.id} forum={forum} />
            ))}
          </div>
        </div>
      </section>

      <section id="guide" className="border-b border-background-200 bg-background-50">
        <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
          <SectionHeading
            eyebrow="发布指南"
            title="投稿之前，先花十分钟读这几篇"
            description="材料怎么整理、渠道怎么挑、隐私怎么保护，这些细节决定了你的线索会不会被认真对待。"
            actionLabel="查看全部指南"
            actionTo="/guide"
          />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {featuredArticles.map((article) => (
              <ArticleCard key={article.slug} article={article} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}